import { useQuery, UseQueryOptions } from 'react-query';
import { useService } from '@core/inversify-react';

import { GetOrderByIdRepoType, IGetOrderByIdRepo } from '../repos';
import { IDetailedOrder } from '../interfaces';

export const useOrderById = (id?: string, options?: UseQueryOptions<IDetailedOrder, Error, IDetailedOrder, string[]>) => {
  const getOrderByIdRepo = useService<IGetOrderByIdRepo>(GetOrderByIdRepoType);

  return useQuery<IDetailedOrder, Error, IDetailedOrder, string[]>(
    ['orders', id || ''],
    async ({ queryKey }) => {
      const [, id] = queryKey;
      const result = await getOrderByIdRepo.execute(id);

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    options,
  );
};
